import type { CreateWebhookSentState, WebhookSentState } from '../outgoing-webhooks/webhook-sent-state.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class WebhookSentStateFactory extends ObjectFactory<WebhookSentState> {
  protected getDefaults(): WebhookSentState {
    return {
      ...baseDocumentFactory.build(),
      entityKey: 'order-id',
      lastSentAt: new Date('2026-01-01T00:00:00.000Z'),
      lastSentState: 'planned',
      webhookConfigId: 'webhook-config-id',
    };
  }

  /** Build a CreateWebhookSentState body (no base document fields). */
  buildCreate(overrides: Partial<CreateWebhookSentState> = {}): CreateWebhookSentState {
    return {
      entityKey: 'order-id',
      lastSentAt: new Date('2026-01-01T00:00:00.000Z'),
      lastSentState: 'planned',
      webhookConfigId: 'webhook-config-id',
      ...overrides,
    };
  }
}

export const webhookSentStateFactory = new WebhookSentStateFactory();
